var DirectPayment = (function (PaymentProviderBase, CheckoutSettings) {

	var DirectPayment = PaymentProviderBase.extend({

		type: 'direct',
		_supportedTypes: [CheckoutSettings.PaymentType.Direct],

        complete: function () {
            var transactionData = {
                paymentType: '',
                selectedPaymentOption: '',
                paymentNonce: '',
                paymentToken: '',
                deviceData: ''
            };

            return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true });
		}
	});

	return DirectPayment;
})(PaymentProviderBase, CheckoutSettings);
